export const REQUIRED_FIELD = 'This field is required';
export const INVALID_EMAIL = 'Please provide a valid email';
export const INVALID_SHORT_PASSWORD = 'Password is too short';
